import { Box, Stack } from '@mui/material';
import { AmountProps } from './types';

/** A currency glyph followed by its figure — the pairing every price and
 * balance in this dialog uses. */
const Amount = ({
  icon,
  children,
  color,
  colorDark,
  size = 17,
  fontSize = 13.5,
}: AmountProps) => (
  <Stack
    direction="row"
    sx={(theme) => ({
      alignItems: 'center',
      gap: 0.75,
      fontSize,
      fontWeight: 700,
      color,
      ...(colorDark ? theme.applyStyles('dark', { color: colorDark }) : {}),
    })}
  >
    <Box component="img" src={icon} alt="" sx={{ height: size, width: size }} />
    {children}
  </Stack>
);

export default Amount;
